/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Provide the sites for your app. Each site includes site id, and its localization configuration.
// You can also provide alias for your locale. They will be used in place of your locale id when generating paths across the app
module.exports = [
    {
        id: 'stokke',
        defaultSite: true,
        isContentOnlySite: true,
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-GR',
            supportedLocales: [
                {id: 'en-AE', preferredCurrency: 'EUR'},
                {id: 'en-AL', preferredCurrency: 'EUR'},
                {id: 'en-AM', preferredCurrency: 'EUR'},
                {id: 'en-AU', preferredCurrency: 'EUR'},
                {id: 'en-AZ', preferredCurrency: 'EUR'},
                {id: 'en-BY', preferredCurrency: 'EUR'},
                {id: 'en-BA', preferredCurrency: 'EUR'},
                {id: 'en-CA', preferredCurrency: 'EUR'},
                {id: 'en-CY', preferredCurrency: 'EUR'},
                {id: 'en-EG', preferredCurrency: 'EUR'},
                {id: 'en-GE', preferredCurrency: 'EUR'},
                {id: 'en-GR', preferredCurrency: 'EUR'},
                {id: 'en-HK', preferredCurrency: 'EUR'},
                {id: 'en-HU', preferredCurrency: 'EUR'},
                {id: 'en-IS', preferredCurrency: 'EUR'},
                {id: 'en-IN', preferredCurrency: 'EUR'},
                {id: 'en-IR', preferredCurrency: 'EUR'},
                {id: 'en-IL', preferredCurrency: 'EUR'},
                {id: 'en-KZ', preferredCurrency: 'EUR'},
                {id: 'en-MY', preferredCurrency: 'EUR'},
                {id: 'en-NZ', preferredCurrency: 'EUR'},
                {id: 'en-QA', preferredCurrency: 'EUR'},
                {id: 'en-SA', preferredCurrency: 'EUR'},
                {id: 'en-RS', preferredCurrency: 'EUR'},
                {id: 'en-SG', preferredCurrency: 'EUR'},
                {id: 'en-ZA', preferredCurrency: 'EUR'},
                {id: 'pt-BR', preferredCurrency: 'EUR'},
                {id: 'ru-BY', preferredCurrency: 'EUR'},
                {id: 'ru-KZ', preferredCurrency: 'EUR'},
                {id: 'ru-UA', preferredCurrency: 'EUR'},
                {id: 'es-AR', preferredCurrency: 'EUR'},
                {id: 'es-CL', preferredCurrency: 'EUR'},
                {id: 'es-CO', preferredCurrency: 'EUR'},
                {id: 'es-CR', preferredCurrency: 'EUR'},
                {id: 'es-MX', preferredCurrency: 'EUR'},
                {id: 'es-PA', preferredCurrency: 'EUR'},
                {id: 'es-PE', preferredCurrency: 'EUR'},
                {id: 'es-PR', preferredCurrency: 'EUR'},
                {id: 'tr-TR', preferredCurrency: 'EUR'},
                {id: 'zh-TW', preferredCurrency: 'EUR'},
                {id: 'zh-HK', preferredCurrency: 'EUR'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'AUT',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'de-AT',
            supportedLocales: [
                {
                    id: 'de-AT',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'BEL',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'nl-BE',
            supportedLocales: [
                {id: 'fr-BE', preferredCurrency: 'EUR'},
                {id: 'nl-BE', preferredCurrency: 'EUR'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'CHE',
        l10n: {
            supportedCurrencies: ['CHF'],
            defaultCurrency: 'CHF',
            defaultLocale: 'de-CH',
            supportedLocales: [
                {id: 'de-CH', preferredCurrency: 'CHF'},
                {id: 'fr-CH', preferredCurrency: 'CHF'},
                {id: 'it-CH', preferredCurrency: 'CHF'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'CHN',
        isContentOnlySite: true,
        l10n: {
            supportedCurrencies: ['CNY'],
            defaultCurrency: 'CNY',
            defaultLocale: 'zh-CN',
            supportedLocales: [
                {
                    id: 'zh-CN',
                    preferredCurrency: 'CNY'
                }
            ]
        }
    },
    {
        id: 'GBR',
        l10n: {
            supportedCurrencies: ['GBP'],
            defaultCurrency: 'GBP',
            defaultLocale: 'en-GB',
            supportedLocales: [
                {
                    id: 'en-GB',
                    preferredCurrency: 'GBP'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'DEU',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'de-DE',
            supportedLocales: [
                {
                    id: 'de-DE',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'DNK',
        l10n: {
            supportedCurrencies: ['DKK'],
            defaultCurrency: 'DKK',
            defaultLocale: 'da-DK',
            supportedLocales: [
                {
                    id: 'da-DK',
                    preferredCurrency: 'DKK'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'ESP',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'es-ES',
            supportedLocales: [
                {
                    id: 'es-ES',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'EUR',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-PT',
            supportedLocales: [
                {id: 'en-BG', preferredCurrency: 'EUR'},
                {id: 'en-HR', preferredCurrency: 'EUR'},
                {id: 'en-CZ', preferredCurrency: 'EUR'},
                {id: 'en-EE', preferredCurrency: 'EUR'},
                {id: 'en-LV', preferredCurrency: 'EUR'},
                {id: 'en-LT', preferredCurrency: 'EUR'},
                {id: 'en-PT', preferredCurrency: 'EUR'},
                {id: 'en-RO', preferredCurrency: 'EUR'},
                {id: 'en-SK', preferredCurrency: 'EUR'},
                {id: 'en-SI', preferredCurrency: 'EUR'},
                {id: 'fr-LU', preferredCurrency: 'EUR'},
                {id: 'de-LU', preferredCurrency: 'EUR'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'FIN',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-FI',
            supportedLocales: [
                {
                    id: 'en-FI',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'FRA',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'fr-FR',
            supportedLocales: [
                {
                    id: 'fr-FR',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'IRL',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-IE',
            supportedLocales: [
                {
                    id: 'en-IE',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'ITA',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'it-IT',
            supportedLocales: [
                {
                    id: 'it-IT',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'JPN',
        l10n: {
            supportedCurrencies: ['JPY'],
            defaultCurrency: 'JPY',
            defaultLocale: 'ja-JP',
            supportedLocales: [
                {
                    id: 'ja-JP',
                    preferredCurrency: 'JPY'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'NLD',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'nl-NL',
            supportedLocales: [
                {
                    id: 'nl-NL',
                    preferredCurrency: 'EUR'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'NOR',
        l10n: {
            supportedCurrencies: ['NOK'],
            defaultCurrency: 'NOK',
            defaultLocale: 'no-NO',
            supportedLocales: [
                {
                    id: 'no-NO',
                    preferredCurrency: 'NOK'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'POL',
        l10n: {
            supportedCurrencies: ['PLN'],
            defaultCurrency: 'PLN',
            defaultLocale: 'pl-PL',
            supportedLocales: [
                {
                    id: 'pl-PL',
                    preferredCurrency: 'PLN'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'RUS',
        isContentOnlySite: true,
        l10n: {
            supportedCurrencies: ['RUB'],
            defaultCurrency: 'RUB',
            defaultLocale: 'ru-RU',
            supportedLocales: [
                {
                    id: 'ru-RU',
                    preferredCurrency: 'RUB'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'SWE',
        l10n: {
            supportedCurrencies: ['SEK'],
            defaultCurrency: 'SEK',
            defaultLocale: 'sv-SE',
            supportedLocales: [
                {
                    id: 'sv-SE',
                    preferredCurrency: 'SEK'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'USA',
        l10n: {
            supportedCurrencies: ['USD'],
            defaultCurrency: 'USD',
            defaultLocale: 'en-US',
            supportedLocales: [
                {
                    id: 'en-US',
                    preferredCurrency: 'USD'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true,
            cookiebotRegions: "{'region':'US','cbid':'7acc1db1-8589-4c22-bde1-7440af58e747'}"
        }
    },
    {
        id: 'KOR',
        l10n: {
            supportedCurrencies: ['KRW'],
            defaultCurrency: 'KRW',
            defaultLocale: 'ko-KR',
            supportedLocales: [
                {
                    id: 'ko-KR',
                    preferredCurrency: 'KRW'
                }
            ]
        },
        gdpr: {
            enableCookiebot: false
        }
    }
]
